import sample1 from '../../../assets/images/kwaba.jpg'
import sample2 from '../../../assets/images/aesthetic.jpg'
import sample3 from '../../../assets/images/aesthetic1.jpg'
import sample4 from '../../../assets/images/aesthetic2.jpg'

export const projects = [
    {
        id: 1,
        img: sample1,
        title: 'kwube',
        description: 'testing  this shit'
    },
    {
        id: 2,
        img: sample2,
        title: 'kwubaaaa',
        description: 'still making some attempts'
    },
    {
        id: 3,
        img: sample3,
        title: 'kwubaaattt',
        description: 'yeah...still on that shit'
    },
    {
        id: 4,
        img: sample4,
        title: 'kwubaaaayyuu',
        description: 'making some attempts'
    }
]